var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mainContent",
    class: {
      'is-chrome-ipad': _vm.isMobileOperatingSystem() && _vm.isChrome,
      'is-ipad': _vm.isMobileOperatingSystem(),
      'is-assessment-accelerator': _vm.isAssessmentAcceleratorActivity
    },
    attrs: {
      "id": "mainContent"
    }
  }, [_vm.isTablet && _vm.usingExternalKeyboard && _vm.topLevelInput ? _c('input', {
    staticClass: "hidden-input",
    attrs: {
      "type": "text",
      "id": "external-key-input",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "none",
      "spellcheck": "false"
    },
    on: {
      "blur": _vm.handleBlur
    }
  }) : _vm._e(), _vm.isPortrait ? _c('div', {
    staticClass: "no-portrait",
    class: {
      'portrait-detected': _vm.isPortrait
    },
    on: {
      "resize": _vm.onOrientationChange
    }
  }, [_c('p', {
    staticClass: "portrait-notice"
  }, [_vm._v("\n      Please rotate your device to landscape orientation\n    ")])]) : _vm._e(), _vm._m(0), _c('div', {
    attrs: {
      "aria-atomic": "true",
      "aria-live": "polite",
      "id": "keyboardingSegmentAlert",
      "role": "alert"
    }
  }), _c('div', {
    attrs: {
      "aria-atomic": "true",
      "aria-live": "polite",
      "id": "screenReaderAlert",
      "role": "alert"
    }
  }), _vm.isInActivity ? _c('div', [_c('portal-target', {
    attrs: {
      "name": "mobile-activity-header"
    }
  })], 1) : _vm._e(), _vm.isInActivity && _vm.isAssessmentAcceleratorActivity ? _c('div', {
    staticClass: "save-activity-button-container"
  }, [_c('portal-target', {
    attrs: {
      "name": "save-activity-button"
    }
  })], 1) : _vm._e(), (_vm.kwtMode === 'curriculum' || _vm.kwtMode === 'tester') && _vm.allowDebug ? _c('debug-panel') : _vm._e(), _vm.isInActivity && _vm.isAssessmentAcceleratorActivity ? _c('div', {
    staticClass: "activity-progress-bar-container"
  }, [_c('portal-target', {
    attrs: {
      "name": "activity-progress-bar"
    }
  })], 1) : _vm._e(), _vm.isInActivity ? _c('div', {
    class: {
      'multiPart-tabs-container': true,
      tablet: _vm.isTablet
    }
  }, [_c('portal-target', {
    attrs: {
      "name": "multiPart-tabs"
    }
  })], 1) : _vm._e(), _c('tbar'), _c('div', {
    staticClass: "contentPanel",
    class: {
      assessmentAccelerator: _vm.viewedIntro && _vm.isAssessmentAcceleratorActivity,
      'chrome-os': _vm.isChromeOS,
      tablet: _vm.isTablet
    }
  }, [_c('div', {
    ref: "capslock",
    staticClass: "capslock",
    attrs: {
      "aria-live": "assertive",
      "role": "alert",
      "aria-hidden": !_vm.isCapsLock
    }
  }, [_vm.capsLockSeverity === 'error' ? _c('p', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s('isCapsLock' ? 'Turn caps off' : '') + "\n      ")]) : _vm._e(), _vm.capsLockSeverity === 'alert' ? _c('p', {
    staticClass: "alert"
  }, [_vm._v("\n        " + _vm._s('isCapsLock' ? 'Caps lock on' : '') + "\n      ")]) : _vm._e()]), _c('router-view', {
    attrs: {
      "transition-mode": "out-in",
      "height": "calc(var(--vh, 1vh) * 100)"
    }
  })], 1), _vm.isInActivity || _vm.isAssessmentAcceleratorActivity ? _c('div', {
    class: {
      'next-activity-button-container': true,
      tablet: _vm.isTablet,
      assessmentAcceleratorTesterActivity: _vm.isAssessmentAcceleratorTesterActivity
    }
  }, [_c('portal-target', {
    attrs: {
      "name": "next-activity-button"
    }
  })], 1) : _vm._e(), _c('modal')], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "check-browser-modal",
    attrs: {
      "id": "checkBrowser"
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Unsupported browser!")])])])]);
}]

export { render, staticRenderFns }